<template>
    <div class="slider slider4">
        <div class="avator" v-if="!status"></div>
        <div class="info-txt">
            <div class="title"></div>
            <div class="take-cnt">
                <!-- 活动首页主任务 :TT1Model="TT1Model" :islogin="haslogged"-->
                <div v-if="!status">
                    <takePage ref="takePageRef" @showTaskLoginModel="showTaskLoginModel" :islogin="haslogged"
                        @showRoleModel="showRoleModel" @showPrizeModel="showPrizeModel" />
                </div>

            </div>
        </div>
        <!-- 活动未登录，点击显示登录弹出框 -->
        <div class="model position-absolute" v-if="taskLoginModel">
            <eventLogin @taskLoginModelClose="taskLoginModelClose" @click="inviteModel"
                @handleEventLoginAgain="handleEventLoginAgain" />
        </div>

        <!-- 抽奖页---点击显示规则弹出框----- d -->
        <div class="model position-absolute" v-if="ruleModel">
            <rules @rulesModelClose="rulesModelClose" />
        </div>
        <!-- 抽奖页-----我的奖品弹出框 ------------->
        <div class="model position-absolute" v-if="prizeModel">
            <prize @prizeModelClose="prizeModelClose" :priseList="rewards" />
        </div>
    </div>
</template>

<script>
// 活动登录
import eventLogin from "./eventComponents/eventLogin.vue";

// 规则的
import rules from "./eventComponents/rules.vue";
//  我的奖品
import prize from './eventComponents/prize.vue';
// 任务主页
import takePage from "./eventComponents/takePage.vue";

export default {
    props: ["onNext", 'mList', 'tickets'],
    components: {
        eventLogin,
        takePage,
        rules,
        prize,
    },
    created() {

        if (localStorage.getItem('zero9_account')) {
            this.haslogged = true
        } else {
            this.haslogged = false
        }

    },
    data() {
        return {
            notLoggedInviteModel: false, // 没有登陆的时候，点击邀请任务显示的弹出框

            errModel: false, // 针对于活动区域--errcode统一弹出框
            haslogged: false, // 是否登录
            mtickets: 0, // 奖券
            // TT1M3Model: false, // 登录后，missions 3弹出商店注册
            taskLoginModel: false, // 活动登录弹出框
            inviteModel: false, // 邀请任务弹出框
            status: false, // false 表示显示任务页， true 显示抽奖
            ruleModel: false, // 活动抽奖-=---规则弹出框
            prizeModel: false, // 活动抽奖----我的奖品
            rewards: {}, // 我的奖品列表
        }
    },
    mounted() {
    },
    watch: {

        tickets(newVal, oldVal) {
            this.mtickets = newVal
        },
    },
    methods: {
        showNotLoggedInviteModel() {
            this.notLoggedInviteModel = true
        },
        // 未登录的情况下，显示登陆弹出框
        showTaskLoginModel(val) {
            this.taskLoginModel = val
            this.$emit("handleEVent", !val, 2);
        },
        // 关闭登陆弹出框
        taskLoginModelClose(val) {
            this.taskLoginModel = val
            this.$emit("handleEVent", !val, 2);
        },
        // 
        handleEventLoginAgain(isNew) {
            this.taskLoginModel = false
            this.$emit('handleSilder4Login', isNew)

        },
        // 抽奖==---显示规则弹出框
        showRoleModel(val) {
            this.ruleModel = val
            this.$emit("handleEVent", !val, 2);
        },
        // 抽奖----关闭规则弹出框
        rulesModelClose(val) {
            this.ruleModel = val
            this.$emit("handleEVent", !val, 2);
        },
        // 抽奖----我的奖品弹出框---
        showPrizeModel(val) {
            this.prizeModel = val
            this.$emit("handlePriseEVent", !val, 2);

        },
        // 抽奖=-==关闭我的奖品弹出框
        prizeModelClose(val) {
            this.prizeModel = val
            this.$emit("handleEVent", !val, 2);
        },


    }
}
</script>

<style lang="scss" scoped>
.slider4 {
    background: url("../../assets/img/m4/bg.png") no-repeat top;
    background-size: cover;
    width: 100%;
    height: 100%;
    position: relative;
    z-index: 9;
    .info-txt {
        width: 866px;
        position: absolute;
        left: 620px;
        top: 45px;
    }
    .take-cnt {
        width: 100%;
        height: 100%;
    }

    // 错误提示框
    .err-m-bg {
        background: url("../../assets/img/common/model-bg.png") no-repeat top;
        background-size: 100% 100%;
        width: 716px;
        height: 339px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            background: url("../../assets/img/common/close.png") no-repeat top;
            background-size: 100% 100%;
            width: 56px;
            height: 49px;
            position: absolute;
            right: 0;
            top: -49px;
            cursor: pointer;

        }

        .err-txt {
            font-family: ONEMobileTitleRegular;
            font-size: 32px;
            font-weight: normal;
            font-stretch: normal;
            color: #000000;
            font-weight: bold;
            text-align: center;
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
        }
    }

    .title {
        background: url("../../assets/img/m4/title.png") no-repeat top;
        background-size: cover;
        width: 710px;
        height: 43px;
        margin: 0 auto;
       
    }

    .avator {
        position: absolute;
        bottom: 0;
        left: 250px;
        z-index: 1;

        background: url("../../assets/img/m4/yr.png") no-repeat top;
        background-size: 100% 100%;
        width: 560px;
        height: 1080px;
    }

}

@media screen and (min-width: 2560px) and (max-width: 3440px) {
    .slider4 {

        .title {
            width: 604px !important;
            height: 37px !important;
            top: 30px !important;

        }

        .take-cnt {
            padding-top: 0 !important;
        }

        .avator {

            width: 448px !important;
            height: 864px !important;
            left: 340px !important;


        }


    }





}
</style>


// WEBPACK FOOTER //
// src/components/publicComponents/slider4.vue